import { render } from "./Design.vue?vue&type=template&id=c1c3803c"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__